export const initialData = {
  workers: [
    { id: 1, name: "Jean Kouassi",  role: "manager", pwd: "1234", email: "jean@example.com" },
    { id: 2, name: "Marie Alabi",   role: "ouvrier", pwd: "5678", email: "" },
  ],
  // ─────────────────────────────────────────────────────────────
// PATCH 2 — Remplacer le tableau `domaines:` dans initialData.js
// Ajout du champ numérique `fcfa` par item de tarif indicatif (ti[])
// et `priceFcfa` au niveau du domaine, requis par le nouveau
// Services.jsx pour la conversion de devise en live.
//
// Règle appliquée :
//  - item.fcfa = nombre  → montant réel, converti FCFA/USD/EUR
//  - item.fcfa = null    → item.prix affiché tel quel (ex: "Sur
//    devis", "5–8%") car ce n'est pas un montant FCFA convertible
// ─────────────────────────────────────────────────────────────
  domaines: [
    {
      id: 1, icon: "💻", name: "FULL STACK & DÉVELOPPEMENT WEB",
      desc: "Applications web et mobiles performantes et sécurisées.",
      services: ["Développement Web & Mobile","Applications & Hébergement","Sécurité & APIs REST","Maintenance & Support","E-commerce & CMS"],
      ti: [
        { svc: "Site vitrine",      fcfa: 200000 },
        { svc: "Site e-commerce",   fcfa: 500000 },
        { svc: "Application web",   fcfa: null, prix: "Sur devis" },
      ],
      images: [], priceFcfa: 200000, priceLabel: "À partir de",
    },
    {
      id: 2, icon: "📊", name: "DATA SCIENCE & INTELLIGENCE ARTIFICIELLE",
      desc: "Exploitez vos données pour des décisions stratégiques.",
      services: ["Audit & Déploiement de modèles","Analyse & MLOps","Tableaux de bord intelligents","Conseil Stratégique Data"],
      ti: [
        { svc: "Dashboard BI", fcfa: 150000 },
        { svc: "Modèle ML",    fcfa: null, prix: "Sur devis" },
      ],
      images: [], priceFcfa: 150000, priceLabel: "À partir de",
    },
    {
      id: 3, icon: "☀️", name: "INSTALLATION SOLAIRE PHOTOVOLTAÏQUE",
      desc: "Systèmes photovoltaïques dimensionnés par nos experts.",
      services: ["Systèmes Photovoltaïques","Dimensionnement & Pose","Maintenance préventive","Batteries & Onduleurs"],
      ti: [
        { svc: "Kit 300W",        fcfa: 500000 },
        { svc: "Kit 1kW",         fcfa: 1200000 },
        { svc: "Kit 3kW",         fcfa: 3500000 },
        { svc: "Maintenance/an",  fcfa: 50000 },
      ],
      images: [], priceFcfa: 500000, priceLabel: "À partir de",
    },
    {
      id: 4, icon: "🔩", name: "FORAGE & INSTALLATION EAU",
      desc: "Solutions complètes d'accès à l'eau potable.",
      services: ["Forage & Château d'Eau","Installation de Suppresseur","Maintenance réseau","Pompes immergées"],
      ti: [
        { svc: "Forage simple",   fcfa: null, prix: "Sur devis" },
        { svc: "Château d'eau",   fcfa: null, prix: "Sur devis" },
      ],
      images: [], priceFcfa: null, price: "Devis gratuit", priceLabel: "",
    },
    {
      id: 5, icon: "🏡", name: "IMMOBILIER",
      desc: "Achat, vente, location et gestion de biens.",
      services: ["Achat & vente de parcelles","Location résidentielle","Recouvrement de loyers","Accompagnement notarial"],
      // Commissions en % — pas des montants FCFA, non convertibles.
      ti: [
        { svc: "Commission vente", fcfa: null, prix: "5–8%" },
        { svc: "Gestion locative", fcfa: null, prix: "10%/mois" },
      ],
      images: [], priceFcfa: null, price: "Commission 5–8%", priceLabel: "",
    },
    {
      id: 6, icon: "🖨️", name: "PHOTOCOPIE, SAISIE & GRAPHISME",
      desc: "Impression, saisie et création graphique professionnels.",
      services: ["Photocopie & Impression","Saisie & mise en page","Création graphique & logos","Impression grand format"],
      ti: [
        { svc: "Photocopie N&B", fcfa: 50,    unit: "page" },
        { svc: "Couleur",        fcfa: 200,   unit: "page" },
        { svc: "Logo",           fcfa: 30000 },
        { svc: "Bannière",       fcfa: 25000 },
      ],
      images: [], priceFcfa: 50, priceLabel: "À partir de",
    },
  ],
  formations: [
  { id: 1, icon: "💻", title: "Développement Web Full Stack", duree: "3 mois", places: "15 places", mode: "Présentiel",
    modules: ["HTML, CSS & JavaScript","React / Vue.js Frontend","Python Flask / Node.js","Bases de données & APIs","Déploiement & DevOps"],
    fcfa: 150000, price: "150 000", currency: "FCFA" },
  { id: 2, icon: "☀️", title: "Installation Solaire Photovoltaïque", duree: "2 semaines", places: "10 places", mode: "Terrain + Classe",
    modules: ["Électricité solaire","Dimensionnement","Pose & câblage","Batteries & régulateurs","Maintenance"],
    fcfa: 80000, price: "80 000", currency: "FCFA" },
  { id: 3, icon: "📊", title: "Data Science & Intelligence Artificielle", duree: "2 mois", places: "12 places", mode: "Présentiel + En ligne",
    modules: ["Python Data Science","Machine Learning","Visualisation","Power BI & Tableau","Projets réels"],
    fcfa: 120000, price: "120 000", currency: "FCFA" },
  { id: 4, icon: "🏡", title: "Agent Immobilier Professionnel", duree: "1 mois", places: "20 places", mode: "Présentiel",
    modules: ["Droit foncier Bénin","Négociation","Évaluation immobilière","Gestion locative","Marketing immobilier"],
    fcfa: 60000, price: "60 000", currency: "FCFA" },
],
  immo: [
    {
      id: 1, icon: "🏗️", title: "Achat & Vente de Parcelles", sub: "Acquisitions sécurisées au Bénin",
      items: [
        { icon: "📋", title: "Vérification juridique",   desc: "Contrôle des titres fonciers avant toute transaction.", price: "" },
        { icon: "🔍", title: "Prospection terrain",      desc: "Identification des parcelles selon vos critères.", price: "" },
        { icon: "📝", title: "Accompagnement notarial",  desc: "Suivi du processus de signature et transfert.", price: "" },
        { icon: "💰", title: "Commission agence",        desc: "Commission négociable selon la valeur du bien.", price: "5–8% du prix de vente" },
      ],
    },
    {
      id: 2, icon: "🏢", title: "Location & Gestion Locative", sub: "Recouvrement et administration de vos biens",
      items: [
        { icon: "🏠", title: "Mise en location",     desc: "Évaluation, annonces, sélection des locataires.", price: "" },
        { icon: "💳", title: "Recouvrement de loyer",desc: "Collecte mensuelle et suivi des impayés.", price: "" },
        { icon: "📊", title: "Reporting mensuel",    desc: "Tableau de bord complet de votre patrimoine.", price: "" },
        { icon: "🔑", title: "Frais de gestion",     desc: "Gestion complète de votre bien locatif.", price: "10% du loyer mensuel" },
      ],
    },
  ],

  // ── KOTOS SHOP — Catalogue e-commerce des applications SaaS ──────
  // Achat en un clic depuis le site, panier intégré, paiement FedaPay.
  // unit: 'mois' (abonnement mensuel) | 'analyse' (à l'usage) | 'devis' (sur devis, pas d'achat direct)
  // ── Réglages boutique (délai de grâce, etc.) — configurable depuis Admin ──
  boutiqueConfig: {
    delaiGraceJours: 3, // jours de tolérance après échéance avant "impayé"/suspension auto
    commissionMarketplacePct: 10, // % gardé par KotosTechnology sur les paiements marketplace (sous-comptes FedaPay)
  },

  produits: [
    {
      id: 1, icon: "☁️", iconImage: "", name: "KotosCloud",
      desc: "Plateforme sécurisée de gestion et d'hébergement pour vos données et applications d'entreprise.",
      longDesc: "KotosCloud héberge vos applications et vos données sur une infrastructure sécurisée, avec sauvegardes automatiques et accès géré par comptes utilisateurs. Idéal pour centraliser vos outils métier.",
      category: "SaaS", priceFcfa: 15000, priceFcfaMax: 30000, unit: "mois",
      badge: "Populaire", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 2, icon: "💊", iconImage: "", name: "Gestion Pharmacie / Stock",
      desc: "Suivi des stocks, ventes, péremption et réapprovisionnement pour pharmacies et commerces.",
      longDesc: "Gérez vos entrées/sorties de stock, recevez des alertes de péremption et de rupture, suivez vos ventes quotidiennes et générez vos rapports en un clic.",
      category: "SaaS", priceFcfa: 20000, priceFcfaMax: 30000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 3, icon: "💰", iconImage: "", name: "Finance & Comptabilité",
      desc: "Facturation, suivi de trésorerie, comptabilité générale et reporting financier.",
      longDesc: "Un outil complet pour éditer vos factures, suivre votre trésorerie en temps réel, tenir votre comptabilité générale et produire vos rapports financiers.",
      category: "SaaS", priceFcfa: 20000, priceFcfaMax: 30000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 4, icon: "👥", iconImage: "", name: "Gestion RH (église & entreprise)",
      desc: "Gestion des membres/employés, présences, contributions ou salaires et communication interne.",
      longDesc: "Centralisez la gestion de vos employés ou de vos membres d'église : présences, contributions/salaires, communication interne et rapports automatisés.",
      category: "SaaS", priceFcfa: 18000, priceFcfaMax: 28000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 5, icon: "🏥", iconImage: "", name: "Gestion Hôpital",
      desc: "Dossiers patients, rendez-vous, facturation et suivi du personnel médical.",
      longDesc: "Digitalisez votre structure de santé : dossiers patients sécurisés, prise de rendez-vous, facturation des actes et suivi du personnel médical.",
      category: "SaaS", priceFcfa: 25000, priceFcfaMax: 30000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 6, icon: "⛪", iconImage: "", name: "PastorLifePro",
      desc: "Outil de gestion pastorale : suivi des fidèles, agenda, prédications et communication de l'église.",
      longDesc: "Suivez vos fidèles, planifiez votre agenda pastoral, archivez vos prédications et communiquez avec votre communauté depuis un seul espace.",
      category: "SaaS", priceFcfa: 12000, priceFcfaMax: 20000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 7, icon: "🚌", iconImage: "", name: "Gestion Voyages (bus & avions)",
      desc: "Réservation de billets, gestion des trajets, des horaires et de la billetterie.",
      longDesc: "Vendez vos billets en ligne, gérez vos trajets et vos horaires, et suivez votre billetterie en temps réel.",
      category: "SaaS", priceFcfa: 20000, priceFcfaMax: 30000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 8, icon: "🎓", iconImage: "", name: "Calcul de Moyenne des Élèves",
      desc: "Saisie des notes et calcul automatique des moyennes et bulletins scolaires.",
      longDesc: "Saisissez les notes de vos élèves et générez automatiquement moyennes et bulletins, prêts à imprimer.",
      category: "SaaS", priceFcfa: 9000, priceFcfaMax: 15000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: false },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 9, icon: "🔎", iconImage: "", name: "Contrôle de Plagiat de Mémoires",
      desc: "Vérification d'originalité et détection de similitudes dans les documents académiques.",
      longDesc: "Vérifiez l'originalité d'un mémoire ou d'une thèse et obtenez un rapport détaillé des similitudes détectées.",
      category: "SaaS", priceFcfa: 15000, priceFcfaMax: 25000, unit: "analyse",
      badge: "", active: true, onDevis: false,
      types: { achat: true, abonnement: false, entretien: false },
      essaiGratuit: false, essaiGratuitJours: 0,
    },
    {
      id: 10, icon: "🏫", iconImage: "", name: "Gestion de Faculté",
      desc: "Gestion administrative et pédagogique : inscriptions, emplois du temps, résultats.",
      longDesc: "Gérez les inscriptions, les emplois du temps et les résultats de votre faculté ou établissement depuis une seule plateforme.",
      category: "SaaS", priceFcfa: 30000, priceFcfaMax: 30000, unit: "mois",
      badge: "", active: true, onDevis: false,
      types: { achat: false, abonnement: true, entretien: true },
      essaiGratuit: true, essaiGratuitJours: 30,
    },
    {
      id: 11, icon: "🛠️", iconImage: "", name: "Application sur mesure",
      desc: "Développement d'une application spécifique adaptée à un besoin métier particulier.",
      longDesc: "Décrivez votre besoin métier : nous concevons et développons une application sur mesure, du cahier des charges à la mise en production.",
      category: "Sur mesure", priceFcfa: 0, priceFcfaMax: 0, unit: "devis",
      badge: "Sur devis", active: true, onDevis: true,
      types: { achat: true, abonnement: false, entretien: false },
      essaiGratuit: false, essaiGratuitJours: 0,
    },
  ],
  // Commandes de la boutique : créées comme transactions de type 'commande'
  // (voir AppContext.saveTransaction) — visibles dans Admin → 🛒 Boutique.

  // ── PIPELINE D'INNOVATION — applications en cours de développement ──
  // Affichées sur le site (section "Pipeline d'innovation") et intégrées
  // automatiquement à la liste déroulante "Service souhaité" du formulaire
  // de contact. Gérable depuis Admin → Boutique (mêmes mécanismes que produits).
  pipeline: [
    {
      id: 1, icon: "🔒", name: "Kotos",
      desc: "Messagerie ultra-sécurisée nouvelle génération pour entreprises et particuliers.",
      longDesc: "Kotos est une plateforme de communication chiffrée de bout en bout, plus moderne et plus complète qu'une messagerie grand public classique : messages, appels vocaux et vidéo HD illimités (individuels et de groupe), appels internationaux, partage de fichiers volumineux, stockage cloud intégré, synchronisation multi-appareils, comptes professionnels avec espaces d'équipe et canaux privés, chiffrement de bout en bout sur toutes les communications, messages éphémères, verrouillage biométrique de l'application, sauvegardes chiffrées, et modération/administration centralisée pour les entreprises. Pensée pour un usage aussi bien personnel que professionnel, en Afrique et à l'international.",
      statut: "En développement", disponible: false,
    },
    {
      id: 2, icon: "💸", name: "Kotos Transaction Mondiale",
      desc: "Transfert d'argent international et carte virtuelle multi-devises pour paiements en ligne sécurisés.",
      longDesc: "Envoyez et recevez de l'argent à l'international, avec une carte virtuelle multi-devises utilisable pour vos paiements en ligne, en toute sécurité.",
      statut: "En développement", disponible: false,
    },
    {
      id: 3, icon: "🏢", name: "Kotos Gestion Entreprise",
      desc: "Suite de gestion tout-en-un : RH, comptabilité, facturation, stocks et projets, en temps réel.",
      longDesc: "Une suite de gestion complète pour piloter les ressources humaines, la comptabilité, la facturation, les stocks et les projets de votre entreprise depuis un seul tableau de bord, en temps réel.",
      statut: "En développement", disponible: false,
    },
    {
      id: 4, icon: "🗳️", name: "Kotos Vote",
      desc: "Vote électronique sécurisé : dépouillement automatisé, résultats fiables et quasi instantanés.",
      longDesc: "Solution de vote électronique sécurisée avec dépouillement automatisé, résultats fiables quasi instantanés et traçabilité complète du scrutin.",
      statut: "En développement", disponible: false,
    },
    {
      id: 5, icon: "🔄", name: "Kotos Converter",
      desc: "Conversion multi-formats de documents (PDF, Word, Excel, images, présentations).",
      longDesc: "Convertissez vos documents entre tous les formats courants (PDF, Word, Excel, images, présentations), y compris la conversion en PowerPoint seule.",
      statut: "En développement", disponible: false,
    },
    {
      id: 6, icon: "🧹", name: "Kotos Desktop Cleaner",
      desc: "Organisation et rangement automatique du bureau : tri des fichiers, classement par type/date.",
      longDesc: "Gardez votre bureau toujours propre et ordonné grâce au tri automatique des fichiers et au classement intelligent par type ou par date.",
      statut: "En développement", disponible: false,
    },
    {
      id: 7, icon: "🛡️", name: "Kotos PC Security Life",
      desc: "Suite de sécurité et d'optimisation PC tout-en-un (Windows 10/11).",
      longDesc: "Antivirus temps réel piloté par IA, nettoyage profond (Deep Cleaner Pro), turbo boost système, VPN intégré, et mise à jour automatique des pilotes et applications.",
      statut: "En développement", disponible: false,
    },
    {
      id: 8, icon: "📱", name: "Kotos Android",
      desc: "Solution logicielle pour usines d'assemblage de smartphones Android.",
      longDesc: "Personnalisation de l'OS, contrôle qualité et préinstallation d'applications pour les usines d'assemblage de smartphones Android.",
      statut: "En développement", disponible: false,
    },
    {
      id: 9, icon: "📚", name: "Kotos Cours de Vacances",
      desc: "Programme intensif d'un mois, chaque mois d'août, de la 6ème à la Terminale.",
      longDesc: "Révisions et remise à niveau intensive pendant les vacances, pour tous les niveaux de la 6ème à la Terminale.",
      statut: "En développement", disponible: false,
    },
    {
      id: 10, icon: "🎯", name: "Kotos Élève Performance",
      desc: "Accompagnement de rentrée : cours résumés, exercices de compréhension et de renforcement.",
      longDesc: "Un accompagnement complet pour bien démarrer l'année scolaire : cours résumés, exercices de compréhension et de renforcement.",
      statut: "En développement", disponible: false,
    },
  ],

  // ── DÉPENSES — pour le calcul du bénéfice dans Admin → Finances ──
  // categorie: 'personnel' (salaires, primes...) | 'autre' (loyer, matériel, abonnements...)
  depenses: [],

  // ── SUIVI DE VISITES — analytics basiques (voir Admin → Finances) ──
  // Rempli automatiquement par le site (voir hooks/useVisitTracking.js).
  // Ne contient QUE des données agrégées/anonymes (ville, pays, appareil) —
  // jamais l'identité réelle ou l'adresse postale d'un visiteur.
  visites: [],

  // ── GESTION DOCUMENTAIRE INTERNE ─────────────────────────────────
  // Aucun accès client — uniquement admin et manager selon le bureau

  // Bureau privé admin : dossiers clients, contrats confidentiels
  // Seul l'admin peut y accéder et déclasser vers bureauxCommun
  docsPrives: [],

  // Bureau commun admin+manager : modèles, références de service
  // Accessible et utilisable par admin ET manager
  docsCommun: [],

  // ── DIGITALISATION D'ENTREPRISES ─────────────────────────────────
digitalisation: {
  titre: "Digitalisation d'Entreprises",
  sousTitre: "Transformez votre secteur avec les outils modernes du 21ème siècle",
  description: "KOTOSTECHNOLOGY accompagne les entreprises, institutions et organisations dans leur transformation numérique complète — de l'audit à la mise en production, avec formation et support continu.",
  secteurs: [
    {
      id: 1, icon: "🏪", name: "Commerce & PME",
      desc: "Digitalisez votre commerce avec une caisse, un site e-commerce, un CRM et un ERP complet.",
      outils: ["Site vitrine & E-commerce", "Caisse enregistreuse digitale", "Gestion des stocks", "CRM clients", "Comptabilité & facturation", "Dashboard & rapports"],
      packs: [
        {
          id: "commerce_starter", name: "Starter",
          color: "#00BFFF", badge: "",
          desc: "Idéal pour débuter votre digitalisation — site + caisse + stocks.",
          inclus: ["Site vitrine professionnel", "Caisse enregistreuse digitale", "Gestion stock basique", "Formation 1 jour", "Support email 3 mois"],
          prixFcfa: 150000, prixUsd: 250, prixEur: 230,
          entretienFcfa: 15000, entretienUsd: 25, entretienEur: 23,
          entretienActif: true,
        },
        {
          id: "commerce_pro", name: "Pro",
          color: "#D4A017", badge: "Recommandé",
          desc: "E-commerce complet + comptabilité + CRM + tableau de bord.",
          inclus: ["Tout le pack Starter", "Boutique e-commerce", "Comptabilité & facturation", "CRM clients", "Dashboard analytique", "Formation 3 jours", "Support prioritaire 6 mois"],
          prixFcfa: 500000, prixUsd: 830, prixEur: 760,
          entretienFcfa: 35000, entretienUsd: 58, entretienEur: 53,
          entretienActif: true,
        },
        {
          id: "commerce_enterprise", name: "Enterprise",
          color: "#00CC88", badge: "Complet",
          desc: "ERP complet multi-boutiques avec API, intégrations et support dédié.",
          inclus: ["Tout le pack Pro", "ERP complet", "Multi-boutiques", "API & intégrations", "Application mobile", "Formation équipe complète", "Support dédié 12 mois"],
          prixFcfa: 2000000, prixUsd: 3300, prixEur: 3050,
          entretienFcfa: 80000, entretienUsd: 133, entretienEur: 122,
          entretienActif: true,
        },
      ],
    },
    {
      id: 2, icon: "🏥", name: "Santé & Cliniques",
      desc: "Digitalisez votre structure de santé — dossiers patients, rendez-vous, pharmacie, laboratoire.",
      outils: ["Dossiers patients sécurisés", "Prise de rendez-vous", "Ordonnances digitales", "Facturation médicale", "Gestion pharmacie", "Rapports Ministry Santé"],
      packs: [
        {
          id: "sante_starter", name: "Starter",
          color: "#00BFFF", badge: "",
          desc: "Dossiers patients + rendez-vous + ordonnances pour petites structures.",
          inclus: ["Dossiers patients sécurisés", "Prise de rendez-vous", "Ordonnances digitales", "Formation 2 jours", "Support email 3 mois"],
          prixFcfa: 200000, prixUsd: 333, prixEur: 307,
          entretienFcfa: 20000, entretienUsd: 33, entretienEur: 31,
          entretienActif: true,
        },
        {
          id: "sante_pro", name: "Pro",
          color: "#D4A017", badge: "Recommandé",
          desc: "Clinique complète avec facturation, pharmacie et laboratoire.",
          inclus: ["Tout le Starter", "Facturation médicale", "Gestion pharmacie interne", "Module laboratoire", "Statistiques patients", "Formation 5 jours", "Support prioritaire 6 mois"],
          prixFcfa: 750000, prixUsd: 1250, prixEur: 1150,
          entretienFcfa: 50000, entretienUsd: 83, entretienEur: 77,
          entretienActif: true,
        },
        {
          id: "sante_enterprise", name: "Enterprise",
          color: "#00CC88", badge: "Complet",
          desc: "Hôpital multi-sites avec télémédecine et rapports Ministry Santé.",
          inclus: ["Tout le Pro", "Multi-sites & filiales", "Télémédecine", "Rapports Ministry Santé", "Application mobile patients", "Formation équipe médicale", "Support dédié 12 mois"],
          prixFcfa: 3000000, prixUsd: 5000, prixEur: 4600,
          entretienFcfa: 100000, entretienUsd: 167, entretienEur: 153,
          entretienActif: true,
        },
      ],
    },
    {
      id: 3, icon: "🎓", name: "Éducation & Universités",
      desc: "Digitalisez votre établissement — inscriptions, notes, bulletins, emplois du temps et paiements.",
      outils: ["Inscriptions en ligne", "Gestion des notes & bulletins", "Emplois du temps", "Paiements scolarité", "App parents & élèves", "Bibliothèque numérique"],
      packs: [
        {
          id: "educ_starter", name: "Starter",
          color: "#00BFFF", badge: "",
          desc: "Inscriptions + notes + bulletins automatiques pour petits établissements.",
          inclus: ["Inscriptions en ligne", "Saisie des notes", "Bulletins automatiques", "Formation 2 jours", "Support email 3 mois"],
          prixFcfa: 180000, prixUsd: 300, prixEur: 276,
          entretienFcfa: 18000, entretienUsd: 30, entretienEur: 28,
          entretienActif: true,
        },
        {
          id: "educ_pro", name: "Pro",
          color: "#D4A017", badge: "Recommandé",
          desc: "Établissement complet avec emplois du temps, paiements et app parents.",
          inclus: ["Tout le Starter", "Emplois du temps", "Paiements scolarité en ligne", "Application parents & élèves", "Gestion des absences", "Formation équipe pédagogique", "Support prioritaire 6 mois"],
          prixFcfa: 600000, prixUsd: 1000, prixEur: 920,
          entretienFcfa: 40000, entretienUsd: 67, entretienEur: 61,
          entretienActif: true,
        },
        {
          id: "educ_enterprise", name: "Enterprise",
          color: "#00CC88", badge: "Complet",
          desc: "Université ou faculté complète avec e-learning et bibliothèque numérique.",
          inclus: ["Tout le Pro", "Module universitaire complet", "Bibliothèque numérique", "Plateforme e-learning", "Gestion des examens", "Diplômes digitaux", "Support dédié 12 mois"],
          prixFcfa: 2500000, prixUsd: 4166, prixEur: 3830,
          entretienFcfa: 90000, entretienUsd: 150, entretienEur: 138,
          entretienActif: true,
        },
      ],
    },
    {
      id: 4, icon: "⛪", name: "Église & Associations",
      desc: "Gérez vos membres, contributions, agenda pastoral et communications depuis un seul espace.",
      outils: ["Gestion des membres", "Suivi des contributions", "Agenda pastoral", "Prédications archivées", "Communication membres", "Multi-antennes"],
      packs: [
        {
          id: "eglise_starter", name: "Starter",
          color: "#00BFFF", badge: "",
          desc: "Membres + présences + communication pour petites communautés.",
          inclus: ["Gestion des membres", "Suivi des présences", "Communication de groupe", "Formation 1 jour", "Support email 3 mois"],
          prixFcfa: 120000, prixUsd: 200, prixEur: 184,
          entretienFcfa: 12000, entretienUsd: 20, entretienEur: 18,
          entretienActif: true,
        },
        {
          id: "eglise_pro", name: "Pro",
          color: "#D4A017", badge: "Recommandé",
          desc: "Contributions + agenda + prédications pour églises établies.",
          inclus: ["Tout le Starter", "Suivi des contributions/dîmes", "Agenda pastoral", "Archive des prédications", "Rapports financiers", "Formation 3 jours", "Support prioritaire 6 mois"],
          prixFcfa: 400000, prixUsd: 667, prixEur: 614,
          entretienFcfa: 30000, entretienUsd: 50, entretienEur: 46,
          entretienActif: true,
        },
        {
          id: "eglise_enterprise", name: "Enterprise",
          color: "#00CC88", badge: "Complet",
          desc: "Multi-antennes + finances + application mobile pour grandes organisations.",
          inclus: ["Tout le Pro", "Gestion multi-antennes", "Finances & comptabilité", "Application mobile membres", "Diffusion en direct (live)", "Formation équipe dirigeante", "Support dédié 12 mois"],
          prixFcfa: 1500000, prixUsd: 2500, prixEur: 2300,
          entretienFcfa: 60000, entretienUsd: 100, entretienEur: 92,
          entretienActif: true,
        },
      ],
    },
  ],
},

  // ─────────────────────────────────────────────────────────────────

  transactions: [],
  contact: {
    tel: "(+229) 01 90 11 10 93",
    email: "innovation@kotostechnology.com",
    email2: "kotostechnology@yahoo.com",
    address: "B.P. 207 GODOMEY/BÉNIN – Cotonou",
    hours: "Lun–Sam : 8h00 – 18h00",
    rccm: "2011/A/016 DU 14/01/2011",
    rccmVille: "NATITINGOU",
    raison: "JEHOVA-JIRE MULTI-SERVICES (J.J.M.S)",
    ifu: "1201200109402",
  },
  paiement: {
    mtn:    "",
    moov:   "",
    celtis: "",
    mobile: "Non renseigné (configurer dans Admin > Paiement)",
    bank:   "Non renseigné (configurer dans Admin > Paiement)",
    other:  "Espèces acceptées en agence",
  },
  factureInfo:
    "KOTOSTECHNOLOGY – JEHOVA-JIRE MULTI-SERVICES\nB.P. 207 GODOMEY/BÉNIN – Cotonou\nRCCM: 2011/A/016 · IFU: 1201200109402\nTel: +229 01 XX XX XX XX\nkotostechnology@yahoo.com · www.kotostechnology.com",
  ads: [],
  // ── GALERIE ENTREPRISE — photos générales chargées par l'admin ────
  photosEntreprise: [],
  // ex: { id, data (base64), caption, ordre }

  // ── PHOTOS PAR DOMAINE — déjà dans domaines[].images, mais on garde compat ──
  // → les photos des domaines sont dans data.domaines[x].images[]

  // ── GESTION ETUDIANTS & ALUMNIS ──────────────────────────────────
  promotions: [],
  // Chaque promotion :
  // { id, domaine (id domaine), titre, dateDebut, dateFin, statut ('en_cours'|'terminee'),
  //   etudiants: [{ id, nom, prenom, email, tel, diplome: false, diplomeDate, alumniNote }] }
};

export const ADMIN_PWD_DEFAULT = "kotos2025";
// ← Ajouter ces 3 clés à l'objet initialData
// (les lignes ci-dessous sont à fusionner manuellement si nécessaire)
